import "./subwidget.css";

import ActiveSubTimWe from "./ActiveSubTimWE";
import CountSubUnSubDailyTimWe from "./CountSubUnSubDailyTimeWe";
import SubHistoryTimWeBH from "./SubHistoryTimWeBH";
import SubPostedTimWe from "./SubPostedTimWe";

const SubWidgetTimWeSA = ({ table, role }) => {
    const colors = ["red", "green", "blue", "brown"];
    const randomIndex = Math.floor(Math.random() * colors.length);
    const randomColor = colors[randomIndex];


    return (
        <div
            className="col-10 "
            style={{
                position: "relative",
                left: "250px",
                top: "100px",
            }}
        >
            <div>
                <div className="row  p-3"></div>

                {role !== "accountant" && (
                    <div className="row justify-content-center">
                        <div className="col-5 shadow ml-5">
                            <h2 className="text-secondary font-weight-bold">
                                Daily Report SA{" "}
                                <span style={{ color: randomColor }}>
                                    {table === "scoretimwe" ? (
                                        <>Score</>
                                    ) : table === "beautytimwe" ? (
                                        <>Beauty</>
                                    ) : (
                                        <>Assistant</>
                                    )}
                                </span>
                            </h2>
                            <div>
                                <CountSubUnSubDailyTimWe table={table + "/countSubUnSubSA"} />
                            </div>
                        </div>

                        <div className="col-5 shadow ml-5">
                            <h2 className="text-secondary font-weight-bold">
                                ActiveSub SA {" "}
                                <span style={{ color: randomColor }}>
                                    {table === "scoretimwe" ? (
                                        <>Score</>
                                    ) : table === "beautytimwe" ? (
                                        <>Beauty</>
                                    ) : (
                                        <>Assistant</>
                                    )}
                                </span>
                            </h2>
                            <div>
                                <ActiveSubTimWe table={table + "/SA"} />
                            </div>
                        </div>
                    </div>
                )}

                {role !== "accountant" && (
                    <div className="row justify-content-center">
                        <div className="col-5 shadow ml-5">
                            <h2 className="text-secondary font-weight-bold">
                                Sub History OM {" "}
                                <span style={{ color: randomColor }}>
                                    {table === "scoretimwe" ? (
                                        <>Score</>
                                    ) : table === "beautytimwe" ? (
                                        <>Beauty</>
                                    ) : (
                                        <>Assistant</>
                                    )}
                                </span>
                            </h2>
                            <div>
                                <SubHistoryTimWeBH table={table + "/subHistorySA"} />
                            </div>
                        </div>

                        <div className="col-5 shadow ml-5">
                            <h2 className="text-secondary font-weight-bold">
                                Posted OM {" "}
                                <span style={{ color: randomColor }}>
                                    {table === "scoretimwe" ? (
                                        <>Score</>
                                    ) : table === "beautytimwe" ? (
                                        <>Beauty</>
                                    ) : (
                                        <>Assistant</>
                                    )}
                                </span>
                            </h2>
                            <div>
                                <SubPostedTimWe table={table + "/getPostedSA"} />
                            </div>
                        </div>
                    </div>
                )}

                {/* End */}
            </div>
        </div >
    );
};

export default SubWidgetTimWeSA;
